import React, { useEffect, useState } from "react";
import {
  CardInnerDiv,
  CardWrapper,
  CloseDiv,
  MainDiv,
  MainSection,
  MainWrapper,
  RightDiv,
  Step1,
  Step2,
  Step3,
} from "./elements";
import {
  arrowicon,
  c98cardimg2,
  c98img,
  checkicon,
  connectbtnimg,
  crossicon,
  divider,
  innerimg,
  maincardimg,
  mobilecardimg,
  spaceimg,
} from "assets";
import { Image } from "react-bootstrap";
import { FaRegQuestionCircle } from "react-icons/fa";
import { IoIosWarning } from "react-icons/io";
import MintComp from "./mint";
import { CommonUtility } from "utility/common";
import { useWalletConnectClient } from "services/walletServices";
import { elgNftAbi } from "utility/contract/elgNftAbi";
import environment from "environment";
import { useAppDispatch } from "store/store";
import { mainModel } from "store/redux/slices/helperSlices/modelSlice";
import { MainModel } from "components/common";
import NodataComp from "components/common/nodataComp";
import { Modal, Tooltip } from "antd";
import ConnectModal from "components/common/modal/connectModel/connectModal";
import { Link } from "react-router-dom";
const MentingNftComp = ({ getUserNfts }) => {
  const { web3Provider, account, chain } = useWalletConnectClient();
  // const data = [
  //   {
  //     name: "NFT ID",
  //     value: "DEF777",
  //   },
  //   {
  //     name: "Element",
  //     value: "Fire",
  //   },
  //   {
  //     name: "Trait",
  //     value: "Golden",
  //   },
  //   {
  //     name: "Equippable",
  //     value: "Shoes",
  //   },
  // ];

  const [step2, setStep2] = useState(true);
  const [registerText, setRegisterText] = useState(false);
  const [domainRegisterText, setdomainRegisterText] = useState(false);
  const [mintDiv, setMintDiv] = useState(false);
  const [userBalance, setUserBalance] = useState(Number);
  const [mintText, setMintText] = useState(false);
  const [mintedToken, setMintedToken] = useState(null);
  const [nftAttributes, setNftAttributes] = useState(null);

  const showMintDiv = () => {
    if (web3Provider) setMintDiv(true);
  };

  const showregisterText = () => {
    if (web3Provider) {
      setRegisterText(true);
      if (userBalance > 0) {
        setMintText(true);
      } else {
        window.open("https://space.id/tld/1#", "_blank");
      }
    }
  };
  const showStep2 = () => {
    if (web3Provider) {
    }
  };
  useEffect(() => {
    if (web3Provider && account && chain) {
      checkUserSpaceNft();
    }
  }, [web3Provider, account, chain]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (web3Provider && account && chain) {
        console.log("CALLED");
        checkUserSpaceNft();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const checkUserSpaceNft = async () => {
    try {
      const contract = CommonUtility.contract(
        web3Provider,
        elgNftAbi,
        environment.SPACE_ID[environment.DEFAULT_CHAIN]
      );
      let userBalance = await contract.methods.balanceOf(account).call();
      // console.log("userBalance", userBalance);
      // userBalance = 1;
      setUserBalance(userBalance);
      setdomainRegisterText(+userBalance > 0 ? true : false);
    } catch (error) {
      console.log("user space nft error", error);
    }
  };
  const [showModal, setShowModal] = useState(false);

  const showConnectModal = () => {
    setShowModal(true);
  };
  return (
    <>
      <Modal
        open={showModal}
        centered
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
        width={714}
      >
        <ConnectModal closeModel={() => setShowModal(false)} />
      </Modal>
      <CloseDiv>
        <Link to="/">
          <Image src={crossicon} />
        </Link>
      </CloseDiv>
      <MainSection>
        <MainDiv>
          <Image src={maincardimg} className="maininnerimg" />
          <Image src={mobilecardimg} className="maininnerimg2" />
          <MainWrapper>
            <div className="card-wrapper">
              <CardWrapper>
                <Image src={c98cardimg2} className="innerimg" />

                <CardInnerDiv>
                  <div className="mask1">
                    <Image src={mintedToken ? mintedToken : innerimg} fluid />
                  </div>
                  <h1>Elemental Legend</h1>

                  {mintedToken && nftAttributes?.length > 0 && nftAttributes.map((item) => (
                    <>
                      <div className="content-div">
                        <h5>{item.name}</h5>
                        <p>{item.value}</p>
                      </div>
                    </>
                  ))}
                </CardInnerDiv>
              </CardWrapper>
            </div>
            {mintDiv ? (
              <>
                <MintComp
                  getUserNfts={getUserNfts}
                  setMintedToken={setMintedToken}
                  setNftAttributes={setNftAttributes}
                />
              </>
            ) : (
              <RightDiv>
                <h1>MINTING STEPS</h1>
                <Step1>
                  <div className="step1-div">
                    <h1>1</h1>
                    <div>
                      <div className="coonect-div">
                        <h5>
                        Connect C98 or WalletConnect &nbsp;
                          <Tooltip
                            title={
                              <span>
                                Coin98 is the leading crypto
                                <br /> super wallet designed to
                                <br /> seamlessly connect a billion
                                <br /> user to crypto world safely
                                <br /> and securely.{" "}
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    window.open("https://coin98.com/wallet")
                                  }
                                >
                                  More details here
                                </span>
                              </span>
                            }
                            placement="right"
                            color="#363636"
                          >
                            <FaRegQuestionCircle fontSize={20} />
                          </Tooltip>
                        </h5>
                      </div>

                      {account ? (
                        <>
                          <div className="connect-text">
                            <Image src={checkicon} />
                            <h1>Connected</h1>
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className="register-btn-div"
                            onClick={showConnectModal}
                          >
                            <Image
                              src={connectbtnimg}
                              alt="button img"
                              className="btn-img"
                            />

                            <h1>
                              <Image src={c98img} />
                              &nbsp; Connect Wallet
                            </h1>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <Image src={divider} className="divider-img" fluid />
                </Step1>
                <Step2
                  className={`${step2 && web3Provider ? "opacity-full" : "opacity-low"
                    }`}
                  onClick={showStep2}
                >
                  <div className="step1-div">
                    <h1>2</h1>
                    <div className="coonect-div">
                      <h5>
                        Register BNB domain on &nbsp;
                        <Image src={spaceimg} />
                        &nbsp;
                        <Tooltip
                          title={
                            <span>
                              Space ID provides you with the
                              <br /> ability to register, mange, and
                              <br /> trade Web3 domain across
                              <br />
                              multiple blockchain networks.
                              <br />
                              <span
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => window.open("https://space.id/")}
                              >
                                More details here
                              </span>
                            </span>
                          }
                          placement="bottomLeft"
                          color="#363636"
                        >
                          <FaRegQuestionCircle fontSize={20} />
                        </Tooltip>
                      </h5>
                      {step2 ? (
                        <div className="step2-div">
                          {registerText ? (
                            <>
                              {domainRegisterText ? (
                                <>
                                  <div className="connect-text">
                                    <Image src={checkicon} />
                                    <h1>Domain Registered</h1>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <h4>
                                    You’ve been redirected to Space ID
                                    <br /> Please come back to this site after
                                    completing registration
                                  </h4>
                                  <h3>
                                    <span>
                                      <a
                                        href="https://space.id/tld/1#"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        Click here
                                      </a>
                                    </span>{" "}
                                    if you haven't been redirected
                                  </h3>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <div
                                className="register-btn-div"
                                onClick={showregisterText}
                              >
                                <Image
                                  src={connectbtnimg}
                                  alt="button img"
                                  className="btn-img"
                                />

                                <h1>Register now</h1>
                              </div>
                              <p>
                                <IoIosWarning fontSize={15} /> Do not close this
                                browser
                              </p>
                            </>
                          )}
                        </div>
                      ) : (
                        <>
                          <p>Not required if you already subscribed </p>
                        </>
                      )}
                    </div>
                  </div>
                  <Image src={divider} className="divider-img" fluid />
                </Step2>
                <Step3
                  className={`${domainRegisterText && web3Provider
                    ? "opacity-full"
                    : "opacity-low"
                    }`}
                >
                  <div className="step3-div">
                    <h1>3</h1>
                    <div className="start-div">
                      <h5>Start Minting!</h5>
                      {domainRegisterText && mintText && (
                        <>
                          <div
                            className="register-btn-div"
                            onClick={showMintDiv}
                          >
                            <Image
                              src={connectbtnimg}
                              alt="button img"
                              className="btn-img"
                            />

                            <h1>
                              <Image src={arrowicon} />
                              &nbsp; Mint now
                            </h1>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </Step3>
              </RightDiv>
            )}
          </MainWrapper>
        </MainDiv>
      </MainSection>
    </>
  );
};

export default MentingNftComp;
